module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "klass": 'ls-modal-large'
    },
    model: {
      value: (_vm.value.show),
      callback: function($$v) {
        _vm.value.show = $$v
      },
      expression: "value.show"
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('div', {
    staticClass: "ls-modal-header"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "close-modal": "",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "ls-modal-title"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.separate_invoice')))])]), _vm._v(" "), _c('form', {
    staticClass: "ls-form ls-form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "ls-modal-body",
    attrs: {
      "data-test": "invoices"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('invoices.details.separate_invoice_information')))]), _vm._v(" "), _c('fieldset', {
    staticClass: "ls-md-margin-bottom row"
  }, [_c('label', {
    staticClass: "ls-label col-md-4 col-xs-12",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('invoices.attributes.due_date'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.due_date')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date'),
      expression: "'required|date'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.separateInvoice.due_date),
      expression: "separateInvoice.due_date"
    }],
    staticClass: "ls-field-sm",
    attrs: {
      "type": "date",
      "data-test": "'invoices.attributes.due_date'",
      "name": _vm.$t('invoices.attributes.due_date')
    },
    domProps: {
      "value": (_vm.separateInvoice.due_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.separateInvoice.due_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('invoices.attributes.due_date'))),
      expression: "errors.has($t('invoices.attributes.due_date'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('invoices.attributes.due_date'))))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-md-4 col-xs-12",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('invoices.details.value'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.details.value')))]), _vm._v(" "), _c('money-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "value": _vm.separateInvoice.value,
      "dataTest": 'invoices.details.value',
      "name": _vm.$t('invoices.details.value')
    },
    on: {
      "updateValue": function (value) {
        _vm.separateInvoice.value = value
      }
    },
    model: {
      value: (_vm.separateInvoice.value),
      callback: function($$v) {
        _vm.separateInvoice.value = $$v
      },
      expression: "separateInvoice.value"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('invoices.details.value'))),
      expression: "errors.has($t('invoices.details.value'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('invoices.details.value'))))])], 1), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-md-4 col-xs-12",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('invoices.details.description'))
    }
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.details.description')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.separateInvoice.description),
      expression: "separateInvoice.description"
    }],
    staticClass: "ls-field",
    attrs: {
      "type": "text",
      "maxlength": "40",
      "data-test": "invoices.details.description",
      "placeholder": _vm.$t('invoices.placeholder.add_separate_invoice'),
      "name": _vm.$t('invoices.details.description')
    },
    domProps: {
      "value": (_vm.separateInvoice.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.separateInvoice.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('entries.description'))),
      expression: "errors.has($t('entries.description'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('invoices.details.description'))))]), _vm._v(" "), _c('char-counter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.errors.has(_vm.$t('invoices.details.description'))),
      expression: "!errors.has($t('invoices.details.description'))"
    }],
    attrs: {
      "max": 40
    },
    model: {
      value: (_vm.separateInvoice.description),
      callback: function($$v) {
        _vm.separateInvoice.description = $$v
      },
      expression: "separateInvoice.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-action ls-float-right"
  }), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-md-12 col-xs-12 ls-display-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.separateInvoice.taxable),
      expression: "separateInvoice.taxable"
    }],
    staticClass: "ls-xs-margin-right",
    attrs: {
      "type": "checkbox",
      "required": false
    },
    domProps: {
      "checked": Array.isArray(_vm.separateInvoice.taxable) ? _vm._i(_vm.separateInvoice.taxable, null) > -1 : (_vm.separateInvoice.taxable)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.separateInvoice.taxable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.separateInvoice.taxable = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.separateInvoice.taxable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.separateInvoice.taxable = $$c
        }
      }
    }
  }), _vm._v(" "), _c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v("Lançar impostos vinculados à assinatura")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-footer"
  }, [_c('button', {
    staticClass: "ls-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "close-modal": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.close')))]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn ls-btn-primary ls-float-right"
  }, [_vm._v(_vm._s(_vm.$t('application.button.launch')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-514b4982"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/invoices/components/ModalSeparateInvoice.vue
// module id = 778
// module chunks = 1